var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Agenda extends Component {
    constructor(isDebugEnabled = false) {
        super('Agenda', isDebugEnabled);
        this.minHeight = null;
        const now = new Date();
        this.currentMonth = now.getMonth() + 1;
        this.currentYear = now.getFullYear();
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Open agenda
            $('.btn-open-agenda').on('click', (event) => {
                event.preventDefault();
                this.open();
            });
            // Close agenda
            $('.btn-close-agenda').on('click', (event) => {
                event.preventDefault();
                this.close();
            });
            // Prev / Next month
            $('.btn-prev-month, .btn-next-month').on('click', (event, button) => {
                event.preventDefault();
                if (button.hasClass('btn-prev-month')) {
                    this.currentMonth--;
                    if (this.currentMonth < 1) {
                        this.currentMonth = 12;
                        this.currentYear--;
                    }
                }
                else if (button.hasClass('btn-next-month')) {
                    this.currentMonth++;
                    if (this.currentMonth > 12) {
                        this.currentMonth = 1;
                        this.currentYear++;
                    }
                }
                this.loadMonth(this.currentMonth, this.currentYear);
            });
            this.success();
        });
    }
    open() {
        return __awaiter(this, void 0, void 0, function* () {
            $('.component-agenda').removeClass('d-none');
            this.loadMonth(this.currentMonth, this.currentYear);
        });
    }
    close() {
        $('.component-agenda').addClass('d-none');
    }
    loadMonth(month, year) {
        return __awaiter(this, void 0, void 0, function* () {
            $('.component-agenda-spinner').removeClass('d-none');
            $('.component-agenda-content').addClass('d-none');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'load_agenda',
                    month: month.toString(),
                    year: year.toString(),
                },
                dataType: 'html'
            });
            const now = new Date();
            $('.component-agenda-footer p').text(`${response.data('monthName')} ${this.currentYear != now.getFullYear() ? this.currentYear : ''}`);
            $('.component-agenda-spinner').addClass('d-none');
            $('.component-agenda-content').empty().append(response).removeClass('d-none');
            if (this.minHeight === null) {
                this.minHeight = $('.component-agenda-content-container').height();
                $('.component-agenda-content-container').css('min-height', `${this.minHeight}px`);
            }
        });
    }
}
